function applyAllFixes() {

  // =============================================
  // 1. MISSING ALT TEXT - Press/Media logos
  // =============================================
  var altMap = {
    'designmilklogo': 'Design Milk logo',
    'techcrunchlogo': 'TechCrunch logo',
    'gizmodo_media_group_logo': 'Gizmodo Media Group logo',
    'forbeslogo': 'Forbes logo'
  };

  document.querySelectorAll('img:not([alt])').forEach(function(img) {
    var src = img.getAttribute('src') || '';
    var matched = false;
    for (var key in altMap) {
      if (src.includes(key)) {
        img.setAttribute('alt', altMap[key]);
        matched = true;
        break;
      }
    }
    if (!matched) {
      img.setAttribute('alt', '');
    }
  });

  // =============================================
  // 2. LINKED IMAGES MISSING ALT TEXT
  // =============================================
  var linkedAltMap = {
    'img_03': 'AZIO Retro Classic keyboard front view',
    'img_05': 'AZIO Retro Classic keyboard angle view'
  };

  document.querySelectorAll('a img:not([alt]), a img[alt=""]').forEach(function(img) {
    var src = img.getAttribute('src') || '';
    var matched = false;
    for (var key in linkedAltMap) {
      if (src.includes(key)) {
        img.setAttribute('alt', linkedAltMap[key]);
        matched = true;
        break;
      }
    }
    if (!matched) {
      var anchor = img.closest('a');
      var href = anchor ? anchor.getAttribute('href') : '';
      img.setAttribute('alt', 'Link to ' + (href || 'page'));
    }
  });

  // =============================================
  // 3. MISSING FORM LABELS
  // =============================================
  var nameInput = document.querySelector('input[name="FNAME"]');
  if (nameInput && nameInput.id && !document.querySelector('label[for="' + nameInput.id + '"]')) {
    var nameLabel = document.createElement('label');
    nameLabel.setAttribute('for', nameInput.id);
    nameLabel.className = 'visually-hidden';
    nameLabel.textContent = 'Your Name';
    nameInput.parentNode.insertBefore(nameLabel, nameInput);
  }

  var emailInput = document.querySelector('input[name="EMAIL"]');
  if (emailInput && emailInput.id && !document.querySelector('label[for="' + emailInput.id + '"]')) {
    var emailLabel = document.createElement('label');
    emailLabel.setAttribute('for', emailInput.id);
    emailLabel.className = 'visually-hidden';
    emailLabel.textContent = 'Email Address';
    emailInput.parentNode.insertBefore(emailLabel, emailInput);
  }

  var checkbox = document.querySelector('input[type="checkbox"][id^="compact-"]');
  if (checkbox && !document.querySelector('label[for="' + checkbox.id + '"]')) {
    var checkboxLabel = document.createElement('label');
    checkboxLabel.setAttribute('for', checkbox.id);
    checkboxLabel.className = 'visually-hidden';
    checkboxLabel.textContent = 'I agree to the terms';
    checkbox.parentNode.insertBefore(checkboxLabel, checkbox.nextSibling);
  }

  document.querySelectorAll('input[name="q"]').forEach(function(searchInput, index) {
    var uniqueId = 'search-q-' + index;
    searchInput.setAttribute('id', uniqueId);

    // Remove any labels we previously generated
    document.querySelectorAll('label.visually-hidden[for="' + uniqueId + '"], label.visually-hidden[for="search-input-' + index + '"]').forEach(function(label) {
      label.parentNode.removeChild(label);
    });

    // Find the theme's own hidden label within this form and reconnect it
    var form = searchInput.closest('form');
    var themeLabel = form ? form.querySelector('label.visuallyhidden') : null;

    if (themeLabel) {
      // Theme already has a label - just point it at the right input
      themeLabel.setAttribute('for', uniqueId);
    } else {
      // No theme label - create one
      var searchLabel = document.createElement('label');
      searchLabel.setAttribute('for', uniqueId);
      searchLabel.className = 'visually-hidden';
      searchLabel.textContent = 'Search';
      searchInput.parentNode.insertBefore(searchLabel, searchInput);
    }
  });

  // =============================================
  // 4. EMPTY SUBMIT BUTTONS
  // =============================================
  document.querySelectorAll('input[type="submit"][name="search"]').forEach(function(btn) {
    if (!btn.value || btn.value.trim() === '') {
      btn.setAttribute('value', 'Submit Search');
      btn.setAttribute('aria-label', 'Submit Search');
    }
  });

  // =============================================
  // 5. SUSPICIOUS / DUPLICATE ALT TEXT
  // =============================================
  var specificAltMap = {
    'about_01': 'AZIO team members working together in the office',
    'img_03': 'AZIO Retro Classic keyboard front view',
    'img_05': 'AZIO Retro Classic keyboard angle view',
    'img_06': 'AZIO Retro Classic keyboard side view',
    'img_07': 'AZIO Retro Classic keyboard close up view',
    'img_08': 'AZIO Retro Classic keyboard top view',
    '06_izo': 'AZIO IZO wireless keyboard product photo'
  };

  document.querySelectorAll('img').forEach(function(img) {
    var src = img.getAttribute('src') || '';
    for (var key in specificAltMap) {
      if (src.includes(key)) {
        img.setAttribute('alt', specificAltMap[key]);
        break;
      }
    }
  });

  // =============================================
  // 20. DUPLICATE ALT TEXT - Product images (universal)
  // =============================================
  var usedAlts = {};

  document.querySelectorAll('img').forEach(function(img) {
    var src = img.getAttribute('src') || '';
    var alt = img.getAttribute('alt') || '';
    if (!alt || alt.trim() === '') return;

    // Only process product gallery images from the products/files CDN path
    if (src.indexOf('/products/') === -1 && src.indexOf('/files/') === -1) return;

    // Extract the filename (without path, extension, query, or size suffix)
    var fileName = src.split('/').pop().split('?')[0].replace(/\.(jpg|jpeg|png|webp|gif)$/i, '');
    fileName = fileName.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '');
    fileName = fileName.replace(/-[0-9]{3,4}x[0-9]{3,4}/gi, '');
    fileName = fileName.replace(/[-_]+/g, ' ').trim();

    // Base product name is the current alt (strip any old thumbnail suffixes)
    var baseName = alt.replace(/( - thumbnail)+/gi, '').trim();

    // Build a descriptive alt: product name + distinguishing filename detail
    var newAlt = baseName;
    if (fileName) {
      newAlt = baseName + ' - ' + fileName;
    }

    // Add thumbnail suffix once for small images
    var width = parseInt(img.getAttribute('width') || '0');
    if (width > 0 && width <= 100) {
      newAlt = newAlt + ' - thumbnail';
    }

    // Ensure uniqueness on the page
    if (usedAlts[newAlt]) {
      usedAlts[newAlt]++;
      newAlt = newAlt + ' ' + usedAlts[newAlt];
    } else {
      usedAlts[newAlt] = 1;
    }

    img.setAttribute('alt', newAlt);
  });
  document.querySelectorAll('img').forEach(function(img) {
    var alt = img.getAttribute('alt') || '';
    if (alt.startsWith('Link to http')) {
      img.setAttribute('alt', 'AZIO Retro Classic keyboard - view product');
    }
    if (alt.length > 100) {
      img.setAttribute('alt', alt.substring(0, 80).trim());
    }
  });

 

  // =============================================
  // 8. UNDERLINED LINKS
  // =============================================
  document.querySelectorAll('u a, a u').forEach(function(el) {
    var uTag = el.closest('u') || el.querySelector('u');
    if (uTag) {
      uTag.style.textDecoration = 'none';
      var anchor = uTag.querySelector('a') || uTag.closest('a');
      if (anchor) {
        anchor.style.textDecoration = 'underline';
      }
    }
  });

  // =============================================
  // 9. SWATCH IMAGES MISSING ALT
  // =============================================
  document.querySelectorAll('img.swatch__image').forEach(function(img) {
    var alt = img.getAttribute('alt') || '';
    if (alt.trim() === '') {
      img.setAttribute('alt', 'Product color variant');
      alt = 'Product color variant';
    }
    var anchor = img.closest('a.swatch');
    if (anchor) {
      anchor.setAttribute('aria-label', alt);
    }
  });

  // =============================================
  // 10. EMPTY SIDEBAR TOGGLE BUTTONS
  // =============================================
  document.querySelectorAll('button.sidebar-block__toggle-icon').forEach(function(btn) {
    btn.setAttribute('aria-label', 'Toggle filter section');
    if (!btn.getAttribute('aria-expanded')) {
      btn.setAttribute('aria-expanded', 'false');
    }
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });

  setTimeout(function() {
    document.querySelectorAll('button.sidebar-block__toggle-icon').forEach(function(btn) {
      btn.setAttribute('aria-label', 'Toggle filter section');
      if (!btn.getAttribute('aria-expanded')) {
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }, 1500);

  // =============================================
  // 11. GLIDER DOTS
  // =============================================
  document.querySelectorAll('.glider-dots').forEach(function(dotContainer) {
    if (!dotContainer.getAttribute('role')) {
      dotContainer.setAttribute('role', 'tablist');
      dotContainer.setAttribute('aria-label', 'Slide navigation');
    }
  });

  document.querySelectorAll('.glider-dot[role="tab"]').forEach(function(dot) {
    var label = dot.getAttribute('aria-label') || ('Page ' + (parseInt(dot.getAttribute('data-index')) + 1));
    dot.setAttribute('aria-label', label);
    dot.setAttribute('aria-selected', dot.classList.contains('active') ? 'true' : 'false');
  });

  // =============================================
  // 12. LINKS MUST HAVE DISCERNIBLE TEXT
  // =============================================
  document.querySelectorAll('a.header__link').forEach(function(link) {
    var hasText = link.textContent.trim() !== '';
    var hasAriaLabel = link.getAttribute('aria-label') && link.getAttribute('aria-label').trim() !== '';
    var hasTitle = link.getAttribute('title') && link.getAttribute('title').trim() !== '';
    var hasAriaLabelledBy = link.getAttribute('aria-labelledby') && link.getAttribute('aria-labelledby').trim() !== '';

    if (!hasText && !hasAriaLabel && !hasTitle && !hasAriaLabelledBy) {
      var href = link.getAttribute('href') || '';
      if (href.includes('login')) {
        link.setAttribute('aria-label', 'Login to your account');
      } else if (href.includes('account')) {
        link.setAttribute('aria-label', 'My account');
      } else if (href.includes('cart')) {
        link.setAttribute('aria-label', 'Shopping cart');
      } else if (href.includes('wishlist')) {
        link.setAttribute('aria-label', 'Wishlist');
      } else if (href.includes('search')) {
        link.setAttribute('aria-label', 'Search');
      } else {
        link.setAttribute('aria-label', 'Navigation link');
      }
    }
  });

  document.querySelectorAll('a.header__link[href="/cart"]').forEach(function(link) {
    if (!link.getAttribute('aria-label')) {
      link.setAttribute('aria-label', 'Shopping cart');
    }
  });

  document.querySelectorAll('a.header__link[href="/account/login"]').forEach(function(link) {
    if (!link.getAttribute('aria-label')) {
      link.setAttribute('aria-label', 'Login to your account');
    }
  });

  document.querySelectorAll('a.mobile-menu__item.item-with-icon[href="/account/login"]').forEach(function(link) {
    if (!link.getAttribute('aria-label')) {
      link.setAttribute('aria-label', 'Login to your account');
    }
  });

  // =============================================
  // 26. QUANTITY SWITCHER FIELD LABEL - builder
  // =============================================
  document.querySelectorAll('input.q-switcher').forEach(function(input) {
    if (!input.getAttribute('aria-label') && !document.querySelector('label[for="' + input.id + '"]')) {
      input.setAttribute('aria-label', 'Quantity');
    }
  });

  // =============================================
  // 27. EMPTY SWATCH LABELS - builder color swatches
  // =============================================
  document.querySelectorAll('label[for^="swatch-"]').forEach(function(label) {
    if (label.textContent.trim() === '' && !label.getAttribute('aria-label')) {
      var forId = label.getAttribute('for') || '';
      // Extract readable name from the for attribute
      var name = forId.replace('swatch-', '').replace(/-/g, ' ').trim();
      label.setAttribute('aria-label', name || 'Color option');
    }
  });

  // =============================================
  // 28. EMPTY BUILDER NAV BUTTONS
  // =============================================
  document.querySelectorAll('a.builder-btn-prev').forEach(function(link) {
    if (!link.getAttribute('aria-label') && link.textContent.trim() === '') {
      link.setAttribute('aria-label', 'Previous step');
    }
  });

  document.querySelectorAll('a.builder-btn-next').forEach(function(link) {
    if (!link.getAttribute('aria-label') && link.textContent.trim() === '') {
      link.setAttribute('aria-label', 'Next step');
    }
  });

  // =============================================
  // 25. NEWSLETTER EMAIL FIELD LABEL
  // =============================================
  document.querySelectorAll('input[name="contact[email]"]').forEach(function(input) {
    if (!input.getAttribute('aria-label') && !document.querySelector('label[for="' + input.id + '"]')) {
      input.setAttribute('aria-label', 'Email address');
    }
  });

  // =============================================
  // 24. LOGIN/RECOVER FORM LABELS
  // =============================================
  var loginFieldLabels = {
    'recover-email': 'Email address',
    'customer_email': 'Email address',
    'customer_password': 'Password'
  };

  Object.keys(loginFieldLabels).forEach(function(fieldId) {
    var input = document.getElementById(fieldId);
    if (input && !input.getAttribute('aria-label') && !document.querySelector('label[for="' + fieldId + '"]')) {
      input.setAttribute('aria-label', loginFieldLabels[fieldId]);
    }
  });

  // =============================================
  // 23. FIX POSITIVE TABINDEX ON LOGIN FORM
  // =============================================
  document.querySelectorAll('[tabindex]').forEach(function(el) {
    var ti = parseInt(el.getAttribute('tabindex'));
    if (ti > 0) {
      el.setAttribute('tabindex', '0');
    }
  });

  // =============================================
  // 21. HIDDEN SEARCH TYPE FIELD - remove from a11y tree
  // =============================================
  document.querySelectorAll('input[name="type"].visuallyhidden').forEach(function(input) {
    input.setAttribute('aria-hidden', 'true');
    input.setAttribute('tabindex', '-1');
    input.setAttribute('aria-label', 'Search type');
    if (!input.id) {
      input.id = 'search-type-hidden';
    }
  });

  // =============================================
  // 17. QUANTITY FIELD MISSING LABEL - PageFly
  // =============================================
  document.querySelectorAll('input[name="quantity"][data-pf-type="QuantityField"]').forEach(function(input) {
    input.setAttribute('aria-label', 'Product quantity');
  });

  // =============================================
  // 19. EMPTY SPLIDE ARROW BUTTONS
  // =============================================
  document.querySelectorAll('button.splide__arrow--prev').forEach(function(btn) {
    if (!btn.getAttribute('aria-label')) {
      btn.setAttribute('aria-label', 'Previous slide');
    }
  });

  document.querySelectorAll('button.splide__arrow--next').forEach(function(btn) {
    if (!btn.getAttribute('aria-label')) {
      btn.setAttribute('aria-label', 'Next slide');
    }
  });

  // =============================================
  // 18. VARIANT SELECT MISSING ACCESSIBLE NAME - PageFly
  // =============================================
  document.querySelectorAll('select.pf-variant-select').forEach(function(select, index) {
    if (!select.getAttribute('aria-label') && !select.getAttribute('aria-labelledby')) {
      var dataKey = select.getAttribute('data-key') || 'Option';
      select.setAttribute('aria-label', dataKey);
    }
    if (!select.id) {
      select.id = 'pf-variant-select-' + index;
    }
    var wrapper = select.closest('.pf-c');
    if (wrapper) {
      var lbl = wrapper.querySelector('label.pf-variant-label');
      if (lbl && !lbl.getAttribute('for')) {
        lbl.setAttribute('for', select.id);
      }
    }
  });
  document.querySelectorAll('select#sort-by, select.sort_by').forEach(function(select) {
    if (!select.getAttribute('aria-label') && !select.getAttribute('aria-labelledby')) {
      select.setAttribute('aria-label', 'Sort products by');
    }
  });

  document.querySelectorAll('select#tag_filter, select.tag_filter').forEach(function(select) {
    if (!select.getAttribute('aria-label') && !select.getAttribute('aria-labelledby')) {
      select.setAttribute('aria-label', 'Filter products by tag');
    }
  });

  // =============================================
  // 14. MISSING MAIN LANDMARK
  // =============================================
  if (!document.querySelector('main, [role="main"]')) {
    var contentArea = document.querySelector(
      '#shopify-section-pagefly-home, ' +
      '.content-for-layout, ' +
      '#MainContent, ' +
      '.main-content, ' +
      '#shopify-section-collection__main, ' +
      '.collection__main, ' +
      '#shopify-section-cart__main, ' +
      '#shopify-section-login-form, ' +
      '#__pf'
    );
    if (contentArea) {
      contentArea.setAttribute('role', 'main');
    }
  }

  // =============================================
  // 15. FIX H3 TO H2 - RC Prestige heading
  // =============================================
  if ((window.location.pathname === '/' || window.location.pathname === '/index') && !document.querySelector('h2.pf-34_[data-a11y-fixed]')) {
    document.querySelectorAll('h3.pf-34_').forEach(function(h3) {
      var h2 = document.createElement('h2');
      Array.from(h3.attributes).forEach(function(attr) {
        h2.setAttribute(attr.name, attr.value);
      });
      h2.innerHTML = h3.innerHTML;
      h2.setAttribute('data-a11y-fixed', 'true');
      h2.style.boxSizing = 'border-box';
      h2.style.color = 'rgb(255, 255, 255)';
      h2.style.cursor = 'pointer';
      h2.style.display = 'inline';
      h2.style.fontFamily = '"DM Serif Text"';
      h2.style.fontSize = '45px';
      h2.style.fontStyle = 'normal';
      h2.style.fontWeight = '400';
      h2.style.height = 'auto';
      h2.style.letterSpacing = 'normal';
      h2.style.lineHeight = '54px';
      h2.style.textAlign = 'center';
      h2.style.textTransform = 'none';
      h2.style.visibility = 'visible';
      h2.style.width = 'auto';
      h2.style.webkitFontSmoothing = 'antialiased';
      h3.setAttribute('aria-hidden', 'true');
      h3.style.display = 'none';
      h3.parentNode.insertBefore(h2, h3.nextSibling);
    });
  }

  // =============================================
  // 22. FIX BLOG CARD H4 TO H2
  // =============================================
  if (!document.querySelector('h2.title[data-a11y-fixed="true"]')) {
    document.querySelectorAll('.blog-card__content h4.title').forEach(function(h4) {
      if (h4.getAttribute('data-a11y-fixed')) return;
      var h2 = document.createElement('h2');
      Array.from(h4.attributes).forEach(function(attr) {
        h2.setAttribute(attr.name, attr.value);
      });
      h2.innerHTML = h4.innerHTML;
      h2.setAttribute('data-a11y-fixed', 'true');
      h2.style.boxSizing = 'border-box';
      h2.style.color = 'rgb(0, 0, 0)';
      h2.style.cursor = 'pointer';
      h2.style.display = 'inline';
      h2.style.fontFamily = 'Roboto, sans-serif';
      h2.style.fontSize = '24px';
      h2.style.fontStyle = 'normal';
      h2.style.fontWeight = '500';
      h2.style.height = 'auto';
      h2.style.letterSpacing = 'normal';
      h2.style.lineHeight = '27px';
      h2.style.overflowWrap = 'break-word';
      h2.style.textAlign = 'left';
      h2.style.textDecorationColor = 'rgb(0, 0, 0)';
      h2.style.textDecorationLine = 'none';
      h2.style.textDecorationStyle = 'solid';
      h2.style.textTransform = 'none';
      h2.style.transition = 'color 0.3s ease-in-out';
      h2.style.width = 'auto';
      h2.style.webkitFontSmoothing = 'antialiased';
      h4.setAttribute('aria-hidden', 'true');
      h4.style.display = 'none';
      h4.parentNode.insertBefore(h2, h4.nextSibling);
    });
  }

  // =============================================
  // 16. FIX SIDEBAR H3 TO H2
  // =============================================
  if (!document.querySelector('h2.sidebar-block__heading[data-a11y-fixed="true"]')) {
    document.querySelectorAll('h3.sidebar-block__heading').forEach(function(h3) {
      if (h3.getAttribute('data-a11y-fixed')) return;
      var h2 = document.createElement('h2');
      Array.from(h3.attributes).forEach(function(attr) {
        h2.setAttribute(attr.name, attr.value);
      });
      h2.innerHTML = h3.innerHTML;
      h2.setAttribute('data-a11y-fixed', 'true');
      h2.style.alignItems = 'center';
      h2.style.boxSizing = 'border-box';
      h2.style.color = 'rgb(0, 0, 0)';
      h2.style.cursor = 'default';
      h2.style.display = 'flex';
      h2.style.fontFamily = 'Roboto, sans-serif';
      h2.style.fontSize = '24px';
      h2.style.fontStyle = 'normal';
      h2.style.fontWeight = '500';
      h2.style.letterSpacing = 'normal';
      h2.style.lineHeight = '36px';
      h2.style.margin = '0px';
      h2.style.padding = '0px';
      h2.style.position = 'relative';
      h2.style.textTransform = 'none';
      h2.style.webkitFontSmoothing = 'antialiased';
      h3.setAttribute('aria-hidden', 'true');
      h3.style.display = 'none';
      h3.parentNode.insertBefore(h2, h3.nextSibling);
    });
  }

  // =============================================
  // 16B. REMOVE aria-expanded FROM span elements
  // =============================================
  document.querySelectorAll('span[aria-expanded]').forEach(function(span) {
    span.removeAttribute('aria-expanded');
  });

  setTimeout(function() {
    document.querySelectorAll('span[aria-expanded]').forEach(function(span) {
      span.removeAttribute('aria-expanded');
    });
  }, 2000);

}

// Run on DOMContentLoaded
document.addEventListener('DOMContentLoaded', applyAllFixes);

// Run again after full page load
window.addEventListener('load', applyAllFixes);

// Run again after 3 seconds to catch PageFly late renders
setTimeout(applyAllFixes, 3000);

// Run after page fully loads with delays
window.addEventListener('load', function() {
  setTimeout(applyAllFixes, 1000);
  setTimeout(applyAllFixes, 2500);
  setTimeout(applyAllFixes, 4000);
  setTimeout(applyAllFixes, 6000);
  setTimeout(applyAllFixes, 8000);
});

// intentionally removed MutationObserver to prevent page slowdown